import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { ItemDetail } from '../../../types/item-detail';

import { IconComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-listung',
  imports: [CdkAccordionModule,
    IconComponent,
    TranslatePipe],
  templateUrl: './listung.html',
  changeDetection: ChangeDetectionStrategy.OnPush })
export class Listung {
  data = input.required<ItemDetail | null>();
  expanded = input.required<boolean>();
}
